const lang = {
	login: ["ចូលគណនី", "Login", "登录"],
	loginShort: ["ចូល", "Login", "登录"],
	register: ["ចុះឈ្មោះ", "Register", "注册"],
	my_account: ["គណនី", "Account", "账户管理"],
	home: ["ទំព័រដើម", "Home", "首页"],
	deposit: ["ដាក់ប្រាក់", "Deposit", "注款"],
	withdraw: ["ដកប្រាក់", "Withdraw", "提款"],
	contact: ["ទំនាក់ទំនង", "Contact", "联系我们"],
	esport: ["កីឡា", "Sport", "体育"],
	casino: ["កាស៊ីណូ", "Casino", "真人娱乐场"],
	fishing: ["បាញ់ត្រី", "Fishing", "钓鱼游戏"],
	slot: ["ស្លតហ្គេម", "Slots", "老虎机"],
	cock_fighting: ["ជល់មាន់", "Cockfighting", "斗鸡"],
	keno: ["ឡូតូ", "Lotto", "基诺游戏"],
	promotion: ["កាផ្តល់ជូន", "Promotions", "促销消息"],
	my_promotion: ["កាផ្តល់ជូនរបស់ខ្ញុំ", "My Promotions", "我的优惠"],
	about: [
	  "គេហទំព័រហ្គេមអនឡាញឈានមុខគេនៅអាស៊ីដែលផ្តល់ជូននូវការលេងល្បែងកំសាន្ត កីឡា កាស៊ីណូអនឡាញ ហ្គេមស្លុត បាញ់ត្រី ជល់មាន់ និងគីណូជាដើម។",
	  "A leading online gaming website in asia. We offer online games such as sports and e-sports betting, live casino, slots games, fishing, cockfighting, keno, etc.",
	  "亚洲第一在线游戏网站。 我们提供在线游戏，例如体育和电子竞技博彩、真人娱乐场、老虎机、钓鱼、斗鸡、基诺等等。",
	],
	method: ["វិធីសាស្រ្តទូទាត់", "Payment Method", "付款方式"],
	about_us: ["ព័ត៌មានអំពីយើង", "About Us", "关于我们"],
	open_account: ["បើកគណនី", "New Account", "注册账户"],
	how_play: ["របៀបលេង", "How to Play", "玩方式"],
	confirm: ["យល់ព្រម", "Confirm", "确定"],
	cancel: ["បោះបង់", "Cancel", "取消"],
	deposit_withdraw: ["ការដាក់ឬដកប្រាក់", "Deposit & Withdraw", "存款 & 提款"],
	terms: ["លក្ខខណ្ឌ", "Terms", "条款"],
	help_text: [
	  "សូមភ្ជាប់ជាមួយសេវាកម្មអតិថិជន។ ក្រុមការងារចាំផ្តល់ព័ត៌មាននូវចំងល់នានា 010 81 9898 / 068 81 9898",
	  "Please contact our customer service for support if you have any inquiry 010 81 9898 / 068 81 9898",
	  "如果有疑问，请联系我们的客服中心。010 81 9898 / 068 81 9898",
	],
	help: ["ស្នើសុំជំនួយ", "Help Center", "帮助中心"],
	copyright: [
	  "Copyright © 2023 98MBET. រក្សាសិទ្ធគ្រប់យ៉ាង",
	  "Copyright © 2023 98MBET. All Rights Reserved.",
	  "Copyright © 2023 98MBET. 版权所有",
	],
	username: ["ឈ្មោះចូលគណនី", "Username", "用户名"],
	password: ["ពាក្យសំងាត់", "Password", "密码"],
	security_number: ["លេខសុវត្តិភាព", "Security", "安全号码"],
	pleaseFill: [
	  "សូមបំពេញព័ត៌មានអោយត្រឹមត្រូវ។",
	  "Please fill in correct information",
	  "请填写正确信息",
	],
	phone: ["លេខទូរស័ព្ទ", "Phone Number", "电话号码"],
	fullname: ["ឈ្មោះពេញអតិថិជន", "Full Name", "全名"],
	confirm_password: ["បញ្ជាក់ពាក្យសំងាត់", "Confirm Password", "确认密码"],
	done_register: [
	  "អបអរសាទរ! អ្នកបានបង្កើតគណនីដោយជោគជ័យ។",
	  "Congratulations! You have successfully registered an account with us.",
	  "恭喜！ 您已成功注册帐户。",
	],
	logout: ["ចាកចេញ", "Logout", "退出"],
	account_info: ["ព័ត៌មានគណនី", "Account", "账户信息"],
	balance_info: ["សមតុល្យគណនីទាំងអស់", "Account Balance", "账户余额"],
	change_password: ["ផ្លាស់ប្តូរពាក្យសំងាត់", "Change Password", "修改密码"],
	transaction: ["ប្រវត្តិប្រតិបត្តិការ", "Transactions", "交易记录"],
	logout_success: [
	  "អរគុណ! អ្នកបានចាកចេញដោយជោគជ័យ។",
	  "Thank you! You have been successfully logged out.",
	  "谢谢！您已成功退出。",
	],
	logout_confirm: [
	  "តើអ្នកពិតជាចង់ចាកចេញមែនទេ?",
	  "Are you sure you want to log out?",
	  "您是否确定要退出吗？",
	],
	bank_name: ["ធានាគារ", "Bank", "銀行"],
	bank_account_name: ["ឈ្មោះគណនី", "Account Name", "账户名"],
	bank_number: ["លេខគណនីធនាគារ", "Bank Account Number", "银行帐号"],
	balance: ["សមតុល្យគណនីគោល", "Main Balance", "余额"],
	balanceSport: ["សមតុល្យគណនី កីឡា", "Sport Balance", "余额"],
	balanceESport: ["សមតុល្យគណនី E-កីឡា", "Esport Balance", "余额"],
	balanceCasino: ["សមតុល្យគណនី កាស៊ីណូ និងជល់មាន់", "Casino & Cockfighting Balance", "余额"],
	balanceFishing: ["សមតុល្យគណនី បាញ់ត្រី", "Fishing Balance", "余额"],
	balanceSlot: ["សមតុល្យគណនី ស្លត", "Slot Balance", "余额"],
	balanceKeno: ["សមតុល្យគណនី ឡូតូ", "Lotto Balance", "余额"],
	balanceCock: ["សមតុល្យគណនី ជល់មាន់", "Cockfighting Balance", "余额"],
	choose_bank: ["ជ្រើសរើសធនាគារ", "Choose A Bank", "选择银行"],
	choose_currency: ["USD/KHR", "USD/KHR", "USD/KHR"],
	save_info: ["រក្សាទុកព័ត៌មាន", "Save", "保存"],
	referral: ["ភ្ជាប់បណ្តាញ", "Referral", "推荐"],
	referral_info: [
	  "អ្នកនឹង​ទទួល​បាន​ប្រាក់​១ដុល្លារភ្លាមៗ រាល់ពេលមិត្តភក្តិរបស់អ្នកចុះឈ្មោះជាសមាជិក និងដាក់ប្រាក់តាមរយៈតំណរភ្ជាប់ខាងក្រោម។ ",
	  "To get 1$ instantly with our Referral program, all you have to do is to ask your friend to create an account via the link below.",
	  "立即获得 1 美元。您只需让您的朋友通过以下链接创建一个帐户就搞定。",
	],
	old_password: ["ពាក្យសំងាត់ចាស់", "Old Password", "旧密码"],
	new_password: ["ពាក្យសំងាត់ថ្មី", "New Password", "新密码"],
	confirm_new_password: [
	  "បញ្ជាក់ពាក្យសំងាត់ថ្មី",
	  "Confirm New Password",
	  "确定新密码",
	],
	change: ["ផ្លាស់ប្តូរ", "Change", "修改"],
	update_info_success: [
	  "អ្នកបានកែប្រែព័ត៌មានដោយជោគជ័យ។",
	  "You have successfully updated your information.",
	  "您已成功更新您的信息。",
	],
	change_password_success: [
	  "អ្នកបានផ្លាស់ប្តូរពាក្យសំងាត់ជោគជ័យ។",
	  "You have successfully changed your password.",
	  "您已成功修改您的密码。",
	],
	choose_deposit_method: [
	  "ជ្រើសរើសវិធីដាក់ប្រាក់",
	  "Choose Deposit Method",
	  "选择存款方式",
	],
	deposit_amount: [
	  "ដាក់ប្រាក់ចំនួន ($)",
	  "Deposit Amount ($)",
	  "注资金额 （$）",
	],
	deposit_amount_khr: [
		"ដាក់ប្រាក់ចំនួន (៛)",
		"Deposit Amount (៛)",
		"注资金额 （៛）",
	 ],
	transfer_amount: [
		"ផ្ទេរប្រាក់ចំនួន (USD)",
		"Transfer Amount (USD)",
		"转账金额（美元）",
	 ],

	 transfer: [
		"ផ្ទេរប្រាក់",
		"Transfer",
		"转移",
	 ],
	 transfer_success: [
		"ការផ្ទេរប្រាក់ជោគជ័យ។",
		"You have successfully transferred your balance.",
		"您已成功转移余额。",
	 ],
	 transfer_to_main: [
		"ផ្ទេរប្រាក់ទៅគណនីគោល",
		"Transfer to Main Balance",
		"转入主余额",
	 ],
	choose_transaction_image: [
	  "ជ្រើសរើសរូបភាពប្រតិបត្តិការ",
	  "Choose A Transaction Attachment",
	  "上传转账图片",
	],
	confirm_deposit: [
	  "តើអ្នកពិតជាចង់ដាក់ប្រាក់មែនទេ​?",
	  "Are you sure you want to fund your account?",
	  "您是否确定要为您的帐户注资吗？",
	],
	deposit_success: [
	  "អ្នកបានស្នើដាក់ប្រាក់ដោយជោគជ័យ។",
	  "You have successfully requested to fund your account.",
	  "您已成功申请向您的账户存款。",
	],
	choose_withdraw_method: [
	  "ជ្រើសរើសវិធីដកប្រាក់",
	  "Choose Withdraw Method",
	  "选择提款方式",
	],
	withdraw_amount: [
	  "ដកប្រាក់ចំនួន ($)",
	  "Withdraw Amount ($)",
	  "提款 ($)",
	],
	withdraw_amount_khr: [
		"ដកប្រាក់ចំនួន (៛)",
		"Withdraw Amount (៛)",
		"提款 (៛)",
	],
	confirm_withdraw: [
	  "តើអ្នកពិតជាចង់ដកប្រាក់មែនទេ​?",
	  "Are you sure you want to withdraw your money?",
	  "您是否确定要提款吗？",
	],
	withdraw_success: [
	  "អ្នកបានស្នើដកប្រាក់ដោយជោគជ័យ។",
	  "You have successfully requested to withdraw fund from your account.",
	  "您已成功申请提款。",
	],
	total_amount: ["ចំនួនទឹកប្រាក់", "Amount", "金额"],
	request_date: ["ថ្ងៃស្នើ", "Date", "申请日期"],
	bank_account: ["គណនីធនាគារ", "Bank", "银行账户"],
	deposit_method: ["វិធីដាក់ប្រាក់", "Method", "注款方式"],
	withdraw_method: ["វិធីដកប្រាក់", "Method", "提款方式"],
	not_available: ["មិនមាន", "Not Available", "没信息"],
	open_account_slogan: [
	  "ងាយស្រួលចុះឈ្មោះបើកគណនី",
	  "Open an account with ease",
	  "快速注册",
	],
	game: ["ល្បែងកំសាន្ត", "Games", "游戏"],
	game_slogan: [
	  "ល្បែងកំសាន្តដ័សំបូរបែប",
	  "Wide variety of games",
	  "种类繁多的游戏",
	],
	deposit_withdraw_slogan: [
	  "ដាក់ឬដកប្រាក់រហ័សងាយស្រូល",
	  "Instant money deposit and withdrawal",
	  "即刻注款及提款",
	],
	confidence: ["ទំនុកចិត្ដខ្ពស់", "Confidence", "充满信心"],
	confidential: ["រក្សាការសម្ងាត់", "Confidential", "高度机密"],
	secure: ["សុវត្ថិភាពបំផុត", "Most Secure", "顶级安全"],
	easy: ["ស្រួលប្រើប្រាស់", "Easy To Use", "便于使用"],
	fast: ["ប្រតិបត្តិការរហ័ស", "Fast Transaction", "快速移帐"],
	good_service: ["សេវាកម្មល្អបំផុត", "Good Service", "良好服务"],
	copy: ["គប់ពី", "Copy", "复制"],
	copied: ["បានគប់ពី", "Copied", "已复制"],
	search: ["ស្វែងរក", "Search", "搜索"],
	tests: ["khmer", "English", "Chinese"],
	tests: ["khmer", "English", "Chinese"],
	tests: ["khmer", "English", "Chinese"],
	tests: ["khmer", "English", "Chinese"],
	tests: ["khmer", "English", "Chinese"],
	tests: ["khmer", "English", "Chinese"],
 };

 export default lang;



// WEBPACK FOOTER //
// ./src/config/locale.js